import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"


export function getPrice({ price, discount }: any) {
    return price - (discount * price) / 100;
}

 
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}